import { sha256Hex } from './sha256';

export const reactionSummaryNameFromResource = (resource: string) => {
  return `reactionSummaries/${sha256Hex(resource).substring(0, 32)}`;
};
